import { render, staticRenderFns } from "./ScrollableVideoSegement.vue?vue&type=template&id=64a0a280&scoped=true&"
import script from "./ScrollableVideoSegement.vue?vue&type=script&lang=js&"
export * from "./ScrollableVideoSegement.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableVideoSegement.vue?vue&type=style&index=0&id=64a0a280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a0a280",
  null
  
)

export default component.exports